// LINE is mainstream only in Japan, Thailand, Taiwan and Indonesia; elsewhere its button is noise.
const REGIONS = new Set(['JP', 'TH', 'TW', 'ID'])
const LANGUAGES = new Set(['ja', 'th', 'id'])
const TIME_ZONES = new Set([
  'Asia/Tokyo',
  'Asia/Bangkok',
  'Asia/Taipei',
  'Asia/Jakarta',
  'Asia/Pontianak',
  'Asia/Makassar',
  'Asia/Jayapura',
])

/** From the device's locales (e.g. "th-TH", "zh-Hant-TW") and IANA time zone. */
export function inLineRegion(locales: readonly string[], timeZone?: string | null): boolean {
  if (timeZone && TIME_ZONES.has(timeZone)) return true
  return locales.some((tag) => {
    const parts = tag.replace(/_/g, '-').split('-')
    return (
      LANGUAGES.has(parts[0].toLowerCase()) ||
      parts.slice(1).some((p) => p.length === 2 && REGIONS.has(p.toUpperCase()))
    )
  })
}
